module.exports = __webpack_public_path__ + "img/requested.c5da0554.svg";